import {
  createBrowserRouter, Navigate,
} from 'react-router-dom';
import Layout from '../layout';
import ErrorPage from '../pages/ErrorPage';
import MapView from '../pages/MapView';
import Login from '../pages/Login';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Navigate to="/login" replace />,
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/app',
    element: (<Layout />),
    errorElement: <ErrorPage />,
    children: [
      {
        path: 'map',
        element: <MapView />,
      },
      {
        path: '',
        element: <Navigate to="/app/map" replace />,
      },
      {
        path: '*',
        element: <Navigate to="/app/map" replace />,
      },
    ],
  },
  {
    path: '/supervisor',
    element: (<Layout />),
    errorElement: <ErrorPage />,
    children: [
      {
        path: 'app/map',
        element: <MapView />,
      },
      {
        path: '',
        element: <Navigate to="/supervisor/app/map" replace />,
      },
      {
        path: '*',
        element: <Navigate to="/supervisor/app/map" replace />,
      },
    ],
  },
]);

export default router;
